(function () {
  try {
    class LanguageSwitcher {
      constructor(options = {}) {
        this.options = Object.assign(
          {
            targetElement: null, // 目标元素选择器（适用于所有定位模式）
            position: "append", // 插入位置: 'append'、'prepend'、'after'、'prev'
            style: {}, // 自定义样式对象，用于设置切换器容器样式
            languages: [
              // 支持的语言列表
              {
                code: "en",
                name: "English",
                url: "/en",
                icon: "https://cdn.shopify.com/s/files/1/0599/1350/2814/files/flag-en.png?v=1747971138",
              },
              {
                code: "de",
                name: "Deutsch",
                url: "/",
                icon: "https://cdn.shopify.com/s/files/1/0599/1350/2814/files/flag-de.png?v=1747971139",
              },
              // {
              //   code: "fr",
              //   name: "Français",
              //   url: "/fr",
              //   icon: "https://cdn.shopify.com/s/files/1/0599/1350/2814/files/flag-fr.png?v=1747971139",
              // },
            ],
            defaultLanguage: "de", // 默认语言
            autoDetectLanguage: false, // 是否自动检测浏览器语言
            useLocalStorage: true, // 是否使用本地存储记住用户选择
            storageKey: "selected_language", // 本地存储的键名
            onChange: null, // 语言变更回调
            alwaysShowGlobe: false, // 语言切换后显示国旗图标而不是地球
            isMobile: false, // 是否为移动端模式
            dropdownAlign: "right", // 下拉菜单对齐方式: 'left'、'right'
          },
          options
        );
        // 用户当前访问站点的语言
        this.currentLanguage = window.currentLangauge || this.options.defaultLanguage;
        this.isMobile = this.options.isMobile || this.detectMobile();
        // 插入样式
        this.insertStyles();

        // 初始化组件
        this.init();
        let currentLanguage = this.determineInitialLanguage()
        // 这里将会对比访问地址的语言和目标规则的语言
        this.changeLanguage(currentLanguage)
      }

      // 插入样式
      insertStyles() {
        const styleId = "hq-language-switcher-styles";

        // 如果样式已存在，不重复添加
        if (document.getElementById(styleId)) {
          return;
        }

        // 创建样式元素
        const style = document.createElement("style");
        style.id = styleId;

        // 添加样式内容
        style.textContent = `
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }

            /* 语言切换器的基本样式 */
            .hq-language-switcher {
              position: relative;
              display: flex;
              align-items: center;
              cursor: pointer;
              -webkit-user-select: none;
              user-select: none;
            }

            /* 当前语言显示区域 */
            .hq-current-language {
              display: flex;
              align-items: center;
              gap: 7px;
            }

            /* 语言图标 */
            .hq-globe-icon {
              width: 22px;
              display: flex;
            }
            .hq-globe-icon img {
              width: 100%;
              height: auto;
            }

            /* 下拉箭头 */
            .hq-arrow {
              transition: transform 0.3s;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              transform-origin: center center;
              font-size: 12px;
            }
            
            .hq-arrow svg {
              display: block;
              transform-origin: center center;
            }

            /* 下拉菜单 */
            .hq-language-dropdown {
              position: absolute;
              margin-top: 8px;
              top: 100%;
              left: 0;
              background-color: white;
              border-radius: 5px;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
              padding: 7px;
              min-width: 110px;
              box-sizing: border-box;
              display: none;
              z-index: 1000;
            }
            
            /* 菜单右对齐 */
            .hq-language-switcher.hq-align-right .hq-language-dropdown {
              right: 0;
              left: auto;
            }

            /* 显示下拉菜单 */
            .hq-language-switcher.hq-active .hq-language-dropdown {
              display: block;
            }

            /* 旋转箭头 */
            .hq-language-switcher.hq-active .hq-arrow {
              transform: rotate(180deg);
            }

            /* 语言选项 */
            .hq-language-option {
              display: flex;
              align-items: center;
              gap: 7px;
              padding: 8px;
              cursor: pointer;
              transition: background-color 0.2s;
              border-radius: 5px;
            }

            .hq-language-option:hover {
              background-color: #f5f5f5;
            }

            /* 当前选中的语言 */
            .hq-language-option.hq-selected {
              color: #764b39;
              text-decoration: underline;
            }
            
            .hq-language-option img {
              width: 21px;
              height: auto;
            }
            
            .hq-language-option span {
              font-size: 14px;
              line-height: 120%;
            }

            /* 国旗图标 */
            .hq-flag-icon {
              width: 28px;
              height: 20px;
              object-fit: cover;
            }
            
            .hq-language-text {
              font-size: 14px;
              line-height: 120%;
              margin-left: 7px;
              position: relative;
            }

            .hq-language-text::before {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: -7px;
              content: "";
              width: 1px;
              height: 13px;
              background-color: #000;
            }

            /* 移动端样式 */
            @media (max-width: 768px) {
              .hq-language-switcher {
                padding: 8px;
              }
              
              .hq-language-switcher.hq-mobile .hq-current-language .hq-language-text {
                display: none !important; /* 移动端不显示当前语言文本 */
              }
              
              .hq-language-switcher.hq-mobile .hq-current-language .hq-arrow {
                display: none !important; /* 移动端不显示箭头 */
              }
            }
          `;

        // 添加到文档头部
        document.head.appendChild(style);
      }

      // 确定初始语言
      determineInitialLanguage() {
        let language = this.options.defaultLanguage;

        // 从本地存储读取
        if (this.options.useLocalStorage) {
          const storedLanguage = localStorage.getItem(this.options.storageKey);
          if (storedLanguage && this.isValidLanguage(storedLanguage)) {
            return storedLanguage;
          }
        }

        // 自动检测浏览器语言
        if (this.options.autoDetectLanguage) {
          const browserLang = this.getBrowserLanguage();
          if (this.isValidLanguage(browserLang)) {
            return browserLang;
          }
        }

        return language;
      }

      // 获取浏览器语言
      getBrowserLanguage() {
        const fullLang = navigator.language || navigator.userLanguage || "en";
        // 取语言代码的前两个字符，如zh-CN -> zh, en-US -> en
        return fullLang.split("-")[0];
      }

      // 检查语言是否有效（是否在配置的语言列表中）
      isValidLanguage(langCode) {
        return this.options.languages.some((lang) => lang.code === langCode);
      }

      // 设置默认语言
      setDefaultLanguage(langCode) {
        if (!this.isValidLanguage(langCode)) {
          console.warn(`Language code "${langCode}" is not valid`);
          return false;
        }
        this.options.defaultLanguage = langCode;
        return true;
      }

      // 检测是否为移动设备
      detectMobile() {
        return window.innerWidth <= 768;
      }

      init() {
        this.createSwitcher();
        this.attachEvents();

        // 监听窗口大小变化，更新移动状态
        window.addEventListener("resize", () => {
          const newIsMobile = this.detectMobile();
          if (this.isMobile !== newIsMobile) {
            this.isMobile = newIsMobile;
            this.updateMobileStyles();
          }
        });
      }

      // 更新移动端样式
      updateMobileStyles() {
        if (this.isMobile) {
          this.element.classList.add("hq-mobile");
        } else {
          this.element.classList.remove("hq-mobile");
        }
      }

      createSwitcher() {
        // 创建主容器
        this.element = document.createElement("div");
        this.element.className = "hq-language-switcher";

        // 应用自定义样式
        if (this.options.style && typeof this.options.style === "object") {
          Object.keys(this.options.style).forEach((key) => {
            const cssKey = this.camelToDash(key);
            this.element.style.setProperty(cssKey, this.options.style[key]);
          });
        }

        // 设置移动端类
        if (this.isMobile) {
          this.element.classList.add("hq-mobile");
        }

        // 设置下拉菜单对齐方式
        if (this.options.dropdownAlign === "right") {
          this.element.classList.add("hq-align-right");
        }

        // 当前语言显示区域
        const currentLang = this.options.languages.find(
          (lang) => lang.code === this.currentLanguage
        );
        const current = document.createElement("div");
        current.className = "hq-current-language";

        // 图标容器 - 默认显示地球或当前语言的国旗
        const iconContainer = document.createElement("div");
        iconContainer.className = "hq-globe-icon";

        // 初始状态下是否显示地球图标或当前语言国旗
        if (this.options.alwaysShowGlobe) {
          // 显示地球图标
          iconContainer.innerHTML = this.getGlobeIconSvg();
        } else {
          // 显示当前语言的国旗
          iconContainer.innerHTML = this.getFlagHtml(currentLang);
        }

        // 当前语言文本
        const langText = document.createElement("span");
        langText.className = "hq-language-text";
        langText.textContent = currentLang.name;

        // 下拉箭头
        const arrow = document.createElement("span");
        arrow.className = "hq-arrow";
        arrow.innerHTML =
          '<svg viewBox="64 64 896 896" focusable="false" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg>';

        current.appendChild(iconContainer);

        // 如果不是移动端，添加文字和箭头
        if (!this.isMobile) {
          current.appendChild(langText);
          current.appendChild(arrow);
        }

        this.element.appendChild(current);

        // 创建下拉菜单
        const dropdown = document.createElement("div");
        dropdown.className = "hq-language-dropdown";

        // 添加语言选项
        this.options.languages.forEach((lang) => {
          const option = document.createElement("div");
          option.className = `hq-language-option ${lang.code === this.currentLanguage ? "hq-selected" : ""
            }`;
          option.dataset.language = lang.code;

          // 添加国旗图标
          const flagHtml = this.getFlagHtml(lang);
          option.innerHTML = flagHtml;

          // 语言名称
          const name = document.createElement("span");
          name.textContent = lang.name;
          option.appendChild(name);

          dropdown.appendChild(option);
        });

        this.element.appendChild(dropdown);

        // 将切换器添加到容器
        if (
          this.options.position === "after" ||
          this.options.position === "prev"
        ) {
          // after和prev模式直接使用targetElement
          if (!this.options.targetElement) {
            console.error(
              `使用${this.options.position}位置时必须指定targetElement参数`
            );
            return this.element;
          }

          const target = document.querySelector(this.options.targetElement);
          if (!target) {
            console.error(`未找到目标元素: ${this.options.targetElement}`);
            return this.element;
          }

          if (this.options.position === "after") {
            // 插入到目标元素之后作为兄弟元素
            if (target.nextSibling) {
              target.parentNode.insertBefore(this.element, target.nextSibling);
            } else {
              target.parentNode.appendChild(this.element);
            }
          } else {
            // prev模式
            // 插入到目标元素之前作为兄弟元素
            target.parentNode.insertBefore(this.element, target);
          }
        } else {
          // append/prepend模式，将元素作为子元素插入到目标元素中
          if (!this.options.targetElement) {
            console.error("必须指定targetElement参数");
            return this.element;
          }

          const container = document.querySelector(this.options.targetElement);
          if (container) {
            if (this.options.position === "prepend") {
              // 添加到容器的开头
              container.prepend(this.element);
            } else {
              // 默认: 添加到容器的末尾
              container.appendChild(this.element);
            }
          } else {
            console.error(`未找到目标元素: ${this.options.targetElement}`);
          }
        }

        return this.element;
      }

      // 获取地球图标SVG
      getGlobeIconSvg() {
        return `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="2" y1="12" x2="22" y2="12"></line>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            </svg>
          `;
      }

      // 获取国旗HTML
      getFlagHtml(lang) {
        return `<img src="${lang.icon}" alt="${lang.name}" class="hq-flag-icon">`;
      }

      attachEvents() {
        // 点击切换器显示/隐藏下拉菜单
        this.element
          .querySelector(".hq-current-language")
          .addEventListener("click", (e) => {
            e.stopPropagation(); // 阻止事件冒泡
            this.element.classList.toggle("hq-active");
          });

        // 点击语言选项切换语言
        const options = this.element.querySelectorAll(".hq-language-option");
        options.forEach((option) => {
          option.addEventListener("click", (e) => {
            e.stopPropagation(); // 阻止事件冒泡
            const langCode = option.dataset.language;
            this.changeLanguage(langCode);
            this.element.classList.remove("hq-active");
          });
        });

        // 点击外部关闭下拉菜单
        document.addEventListener("click", (e) => {
          if (!this.element.contains(e.target)) {
            this.element.classList.remove("hq-active");
          }
        });
      }

      changeLanguage(langCode) {
        console.log('langCode === this.currentLanguage', langCode)
        if (langCode === this.currentLanguage) return;

        // 更新当前语言
        this.currentLanguage = langCode;
        const currentLang = this.options.languages.find(
          (lang) => lang.code === langCode
        );

        // 更新当前语言显示
        const langTextEl = this.element.querySelector(".hq-language-text");
        if (langTextEl) {
          langTextEl.textContent = currentLang.name;
        }

        // 更新图标：将当前图标替换为选中语言的国旗
        if (!this.options.alwaysShowGlobe) {
          const iconContainer = this.element.querySelector(".hq-globe-icon");
          if (iconContainer) {
            // 清空当前图标内容
            iconContainer.innerHTML = "";
            // 创建新的图标内容
            const newIconHtml = this.getFlagHtml(currentLang);

            // 为了调试，添加一个数据属性表明图标已更新
            iconContainer.setAttribute("data-updated", "true");

            // 使用临时容器解析HTML并添加到DOM
            const tempContainer = document.createElement("div");
            tempContainer.innerHTML = newIconHtml;

            // 将解析好的内容添加到图标容器
            while (tempContainer.firstChild) {
              iconContainer.appendChild(tempContainer.firstChild);
            }
          }
        }

        // 更新选中状态
        const options = this.element.querySelectorAll(".hq-language-option");
        options.forEach((option) => {
          if (option.dataset.language === langCode) {
            option.classList.add("hq-selected");
          } else {
            option.classList.remove("hq-selected");
          }
        });

        // 保存用户选择到本地存储
        if (this.options.useLocalStorage) {
          localStorage.setItem(this.options.storageKey, langCode);
        }

        // 触发回调
        if (typeof this.options.onChange === "function") {
          this.options.onChange(langCode);
        }

        // 切换路径
        let url = location.href;
        console.log(`语言已切换到: ${langCode}`);

        // 和当前站点默认语言匹配中了，所以直接访问没有语言的url
        if (this.options.defaultLanguage == langCode) {
          const langauge_root = window.Shopify.routes.root.slice(0, -1)
          location.href = url.replace(langauge_root, '');
          return
        }


        switch (langCode) {
          case "en":
            url = url.replace(location.origin, `${location.origin}/en`);
            break;
          case "de":
            url = url.replace(location.origin, `${location.origin}/de`);
        }

        location.href = url;
      }

      // 辅助方法：驼峰命名转换为横线命名
      camelToDash(str) {
        return str.replace(/([A-Z])/g, "-$1").toLowerCase();
      }
    }

    window.LanguageSwitcher = LanguageSwitcher;
  } catch (error) {
    console.log('init langauge switcher error!!')
  }
})();
